import {
  ApolloClient,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';
import isSSR from '#utils/is-ssr';
import getConfigVars from '#utils/get-config-vars';

const { GRAPHQL_SERVER_EXTERNAL } = getConfigVars({
  GRAPHQL_SERVER_EXTERNAL: '/api/graphql',
});

const getBaseOptions = () => {
  if (isSSR()) {
    // We don't want any cache to be stored server side
    return {
      persistedQueries: false,
      ssrMode: true,
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    };
  } else {
    // We immediately show results, but check in the background if any changes occurred, and eventually update the view
    return {
      ssrMode: false,
      query: {
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all',
      },
    };
  }
};

const createDevClient = (): ApolloClient<NormalizedCacheObject> => {
  const uri = isSSR()
    ? process.env.GRAPHQL_SERVER_INTERNAL
    : GRAPHQL_SERVER_EXTERNAL;

  const baseOptions = getBaseOptions();

  return new ApolloClient({
    uri,
    credentials: 'same-origin',
    cache: new InMemoryCache(),
    ...baseOptions,
    // ATTENTION:
    // If you want to use ApolloDevTools in Storybook you have to open the story in standalone mode.
    // If not then it can't connect to the apolloClient instance because it's attached to the wrong window
    // connectToDevTools: true,
  });
};

export default createDevClient;
